import { CheckRounded } from '@mui/icons-material';
import styled from 'styled-components';

interface CopyBlockProps {
  width: number,
  height: number
}

const CopyBlock = styled.div<CopyBlockProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: ${({ theme }) => theme.palette.success.main};
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    user-select: none;
`;

const CheckIcon = styled(CheckRounded)`
    && {
        transform: scale(0.8);
        margin-right: ${({ theme }) => theme.spacing(1)};
    }
`;

export { CopyBlock, CheckIcon };
